<template>
  <div class="signin-container">
    <div style="margin-bottom: 100px">
      <div class="body-container information">
        <span class="title mb20">Customer</span>
        <text-field
          placeholder="Full Name"
          v-model="fullName.val"
          :error="fullName.error"
          key="recipientName"
        />
        <text-field
          placeholder="Phone Number"
          v-model="phoneNumber.val"
          :error="phoneNumber.error"
          key="senderName"
        />
      </div>
      <div class="body-container service">
        <span class="title mb20">Service</span>
        <div class="list-service">
          <service-item
            v-for="(item, index) in services"
            :key="item.service_id"
            :title="item.type"
            :isSelected="selectedServices.find(s => s.service_id == item.service_id) != null"
            v-on:onItemClick="() => onSelectedItem(index)"
          />
        </div>
      </div>
      <div class="body-container technician">
        <span class="title mb20">Request Technician</span>
        <div class="btn-technician-container normal-button" @click="dialogTechnician = true">
          <span class="tect">{{tech.full_name}}</span>
          <img src="@/assets/ic_triangle.png" style="height: 15px; widht: auto;" />
        </div>
        <div class="source-view normal-button" @click="source = 'Appointment'">
          <span class="source-text">Appointment</span>
          <img
            v-if="source == 'Appointment'"
            src="@/assets/ic_check_active.png"
            style="width: 25px; height: 25px;"
          />
          <img v-else src="@/assets/ic_check_inactive.png" style="width: 25px; height: 25px;" />
        </div>
        <div class="source-view normal-button" @click="source = 'Walking'">
          <span class="source-text">Walk-in</span>
          <img
            v-if="source == 'Walking'"
            src="@/assets/ic_check_active.png"
            style="width: 25px; height: 25px;"
          />
          <img v-else src="@/assets/ic_check_inactive.png" style="width: 25px; height: 25px;" />
        </div>
      </div>
    </div>
    <div class="cta-bottom">
      <gradient-button title="Sign In" @onClick="onSignIn" />
    </div>
    <el-dialog title="Notes" :visible.sync="dialogNote" width="80%">
      <el-input v-model="note" autocomplete="off" placeholder="Enter your notes" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogNote = false">Cancel</el-button>
        <el-button style="margin-left: 10px;" type="primary" @click="onConfirm">Confirm</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="Technicians"
      :visible.sync="dialogTechnician"
      width="80%"
      center="true"
      top="40px"
    >
      <div
        v-for="(item) in technician"
        :key="item.user_id"
        class="btn-tech normal-button"
        @click="() => onSelectTech(item)"
      >
        <span class="tech">{{item.full_name}}</span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import GradientButton from "@/components/GradientButton";
import TextField from "@/components/TextField";
import { getSubDomain } from "@/utils/parser";
import { getServices, getTechnician, createTicket } from "@/api/home";
import ServiceItem from "./components/ServiceItem";
import { Message } from "element-ui";
import { validPhoneNumber } from "@/utils/validate";
export default {
  name: "SignIn",
  components: {
    GradientButton,
    TextField,
    ServiceItem
  },
  data() {
    return {
      source: "Appointment",
      note: "",
      tech: {},
      fullName: {
        val: "",
        error: ""
      },
      phoneNumber: {
        val: "",
        error: ""
      },
      services: [],
      technician: [],
      selectedServices: [],
      dialogNote: false,
      dialogTechnician: false
    };
  },
  methods: {
    onSelectTech(tech) {
      this.tech = tech;
      this.dialogTechnician = false;
    },
    onConfirm() {
      this.dialogNote = false;
      const other = this.services.find(s => s.type == "Other");
      const indexSelected = this.selectedServices.indexOf(other);
      if (this.note != "") {
        if (indexSelected > -1) return;
        this.selectedServices.push(other);
      } else {
        if (indexSelected > -1) {
          this.selectedServices.splice(indexSelected, 1);
        }
        return;
      }
    },
    onSignIn() {
      let error = "";
      if (this.selectedServices.length == 0) {
        error = "Please choose service";
      } else if (this.phoneNumber.val == "") {
        error = "Please fill your phone number";
      } else if (this.fullName.val == "") {
        error = "Please fill your name";
      } else if (!validPhoneNumber(this.phoneNumber.val)) {
        error = "Invalid phone number";
      }
      if (error != "") {
        Message({
          message: error,
          type: "error",
          duration: 5 * 1000
        });
        return;
      }
      const fullUrl = window.location.origin;
      const storeName = getSubDomain(fullUrl);
      createTicket({
        phone_number: this.phoneNumber.val,
        full_name: this.fullName.val,
        customer_source: this.source,
        service_ids: this.selectedServices.map(s => s.service_id),
        assignee_id: this.tech.user_id,
        notes: this.note,
        store: storeName || "classynails"
      })
        .then(res => {
          console.log(res);
          Message({
            message: "Sign in success",
            type: "success",
            duration: 5 * 1000
          });
        })
        .catch(e => {
          console.log(e.message);
        });
    },
    onSelectedItem(index) {
      const item = this.services[index];
      if (item.type == "Other") {
        this.dialogNote = true;
        return;
      }
      const isSelected =
        this.selectedServices.find(s => s.service_id == item.service_id) !=
        null;
      if (isSelected) {
        const indexSelected = this.selectedServices.indexOf(item);
        if (indexSelected > -1) {
          this.selectedServices.splice(indexSelected, 1);
        }
      } else {
        this.selectedServices.push(item);
      }
    }
  },
  created() {
    const fullUrl = window.location.origin;
    const storeName = getSubDomain(fullUrl);
    Promise.all([getServices(), getTechnician(storeName || "classynails")])
      .then(res => {
        this.services = res[0];
        this.technician = res[1];
        console.log(this.technician);
      })
      .catch(e => console.log(e));
  }
};
</script>

<style lang="scss" scoped>
.signin-container {
  display: flex;
  flex-direction: column;
  color: #222222;
  padding-left: 70px;
  padding-right: 70px;
  background-color: white;
  .body-container {
    display: flex;
    flex-direction: column;
  }
  .information {
    margin: 30px 20px 0 20px;
  }
  .service {
    margin: 10px 20px 0 20px;
    .list-service {
      display: flex;
      flex-wrap: wrap;
    }
  }
  .technician {
    margin: 15px 20px 0 20px;
    .btn-technician-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 15px;
      height: 50px;
      border: 1px solid #eeeeee;
      border-radius: 5px;
      background-color: #fafafa;
    }
    .source-view {
      width: 200px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 25px;
      .source-text {
        font-family: "SFUIText-Medium", -apple-system;
        font-weight: 500;
        font-size: 16px;
      }
    }
  }
  .btn-tech {
    padding: 6px;
  }
  .tech {
    font-family: "SFProText-Medium", -apple-system;
    font-weight: 500;
    font-size: 16px;
  }
  .title {
    font-family: "SFProText-Bold", -apple-system;
    font-weight: bold;
    font-size: 20px;
  }
  .cta-bottom {
    position: fixed;
    height: 100px;
    left: calc(50% - 300px);
    right: calc(50% - 300px);
    bottom: 0px;
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    background-color: white;
  }
}
@media only screen and (max-width: 600px) {
  .signin-container {
    padding-left: 0;
    padding-right: 0;
    .cta-bottom {
      left: 20px;
      right: 20px;
      padding-left: 0px;
      padding-right: 0px;
    }
  }
}
</style>